<template>
  <v-layout justify-center>
    <v-flex xs12 md6>
      <v-card flat class="paco_gradient no-radius" height="100%">
        <v-layout justify-center row wrap>
          <v-flex xs6 sm2>
            <v-img src="pacoclean_logo_gris.png" class="mt-3"></v-img>
          </v-flex>
        </v-layout>

        <v-layout justify-center row wrap>
          <v-flex xs10 sm8>
            <v-img src="cocurachef.png" class="mt-2"></v-img>
          </v-flex>
        </v-layout>

        <v-layout justify-center row wrap v-if="device">
          <v-flex xs8 sm5 text-xs-center>
            <v-btn block large @click="login()" color="paco_rouge boutonRond" dark class="login_button mt-5"
              :loading="authLoading">Connexion</v-btn>
          </v-flex>
        </v-layout>

        <!-- <v-content class="pt-5 pb-5 text-xs-center white--text">{{ debug }}</v-content> -->

        <v-content v-if="version" class="pt-4 text-xs-center grey--text text--darken-1">{{ version }}</v-content>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../auth";
export default {
  data() {
    return {
      version: null
    };
  },
  computed: {
    authLoading() {
      return this.$store.state.authLoading;
    },
    debug() {
      return this.$store.state.debug;
    },
    device() {
      return this.$store.state.device;
    }
  },

  methods: {
    // authentification
    login() {
      auth.login(this.device);
    },
    loadVersion() {
      window.cordova.getAppVersion.getVersionNumber().then(version => {
        this.version = version;
      });
    }
  },
  watch: {},
  mounted() {
    // dès que c'est pret
    var inst = this;
    document.addEventListener(
      "deviceready",
      () => {
        inst.loadVersion();
      },
      false
    );
  }
};
</script>

<style>
.login_button {
  font-size: 1.5em;
}

.no-radius {
  border-radius: 0;
}
</style>
